// Smoothly scroll to an element by id, respecting Lenis smooth scroll
// (falls back to native window.scrollTo). Includes a header offset so the
// destination section is not hidden behind the fixed navbar.
export const scrollToId = (id, offset = -80) => {
  const el = document.getElementById(id);
  if (!el) return;
  const lenis = typeof window !== "undefined" ? window.__lenis : null;
  if (lenis && typeof lenis.scrollTo === "function") {
    lenis.scrollTo(el, { offset, duration: 1.1 });
  } else {
    const y = el.getBoundingClientRect().top + window.scrollY + offset;
    window.scrollTo({ top: y, behavior: "smooth" });
  }
};
